/**
 * contacto-context.js — contexto de SKU en el formulario de contacto.
 *
 * Cuando se llega a /pages/contacto desde un producto (PDP) o una fila del
 * catálogo, la URL trae ?ref=<SKU>&qty=<N>&familia=<F>. Liquid no puede leer
 * query params en Shopify, así que este script (que SIEMPRE carga en la
 * página de contacto, independientemente de los adjuntos) los lee y:
 *   - revela el banner de referencia y pinta el SKU + meta (familia/cantidad),
 *   - pone name+value al campo oculto contact[Referencia] → llega al email a
 *     surisa@ y al panel (worker),
 *   - rellena la cantidad estimada,
 *   - preselecciona la familia (match con una opción del <select>; si no
 *     existe, inyecta la opción para que el dato sea fiel igualmente).
 *
 * Sin ?ref no hace nada (formulario normal). Todo vía textContent/value →
 * sin riesgo de inyección. Setup: docs/ARCHITECTURE_contacto_uploads.md
 */
(function () {
  'use strict';

  function run() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }

    var ref = (params.get('ref') || '').trim().slice(0, 120);
    // Sin referencia → formulario normal, banner oculto. También se ignora un
    // token sin sustituir (__REF__) por si un CTA de página lo filtrara.
    if (!ref || ref.indexOf('__') !== -1) return;

    var qty = (params.get('qty') || '').trim().slice(0, 40);
    var familia = (params.get('familia') || '').trim().slice(0, 120);

    // 1. Campo oculto Referencia → email nativo (surisa@) + payload del worker.
    var refField = document.querySelector('[data-ref-field]');
    if (refField) {
      refField.setAttribute('name', 'contact[Referencia]');
      refField.value = ref;
    }

    // 2. Cantidad estimada.
    if (qty) {
      var qtyInput = document.getElementById('ContactForm-qty');
      if (qtyInput && !qtyInput.value) qtyInput.value = qty;
    }

    // 3. Familia: match con una opción existente (trim + case-insensitive);
    //    si no hay, se inyecta la opción para reflejar el dato real.
    var familiaSelected = '';
    if (familia) {
      var select = document.getElementById('ContactForm-family');
      if (select) {
        var target = familia.toLowerCase();
        var matched = null;
        for (var i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          if (!opt.value) continue; // placeholder deshabilitado
          if (opt.value.trim().toLowerCase() === target || (opt.textContent || '').trim().toLowerCase() === target) {
            matched = opt;
            break;
          }
        }
        if (!matched) {
          matched = document.createElement('option');
          matched.value = familia;
          matched.textContent = familia;
          select.appendChild(matched);
        }
        matched.selected = true;
        familiaSelected = matched.textContent || familia;

        var hint = document.querySelector('[data-familia-hint]');
        if (hint) hint.hidden = false;
      }
    }

    // 4. Banner: SKU + meta (familia · cantidad).
    var skuEl = document.querySelector('[data-ref-sku]');
    if (skuEl) skuEl.textContent = ref;

    var metaParts = [];
    if (familiaSelected) metaParts.push('Familia: ' + familiaSelected);
    if (qty) metaParts.push('Cantidad: ' + qty);
    var metaEl = document.querySelector('[data-ref-meta]');
    if (metaEl && metaParts.length) {
      metaEl.textContent = metaParts.join(' · ');
      metaEl.hidden = false;
    }

    var banner = document.querySelector('[data-ref-banner]');
    if (banner) banner.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
